import { useEffect, useRef, useState } from 'react';
import { Smile } from 'lucide-react';

const EMOJIS = [
  '😀', '😂', '🙂', '😉', '😍', '😘', '😎', '🤔', '😅', '😢',
  '😮', '😴', '👍', '👎', '🙏', '👏', '💪', '🤝', '✌️', '👋',
  '❤️', '🔥', '✨', '🎉', '✅', '❌', '⚠️', '📎', '📅', '⏰',
] as const;

/**
 * Sélecteur d'émojis minimal : une grille fixe plutôt qu'une bibliothèque tierce, pour un
 * usage occasionnel dans un fil de support (pas un besoin de couverture Unicode complète).
 */
export function EmojiPicker({ onSelect }: { onSelect: (emoji: string) => void }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) {
      return;
    }

    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        aria-label="Insérer un emoji"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        className="text-ink-400 hover:text-ink-700"
      >
        <Smile className="size-5" />
      </button>

      {open ? (
        <div className="absolute bottom-full left-0 z-10 mb-2 grid w-64 grid-cols-6 gap-1 rounded-card border border-ink-100 bg-white p-2 shadow-raised">
          {EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              onClick={() => {
                onSelect(emoji);
                setOpen(false);
              }}
              className="flex size-9 items-center justify-center rounded-input text-lg hover:bg-ink-50"
            >
              {emoji}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
